import { Head, router } from "@inertiajs/react"
import { PreTestGuidance } from "@/components/VocationalTest/PreTestGuidance"

export default function PreTestGuidancePage() {
  return (
    <>
      <Head title="Antes de comecar" />
      <PreTestGuidance
        onBack={() => router.visit("/")}
        onContinue={() => router.visit("/welcome")}
      />
    </>
  )
}
